export default {
    setMineReports(state, payload) {
        state.mineReports = payload;
    },
    setReportCenterReports(state, payload) {
        state.reportCenterReports = payload;
    },
    setOtherReports(state, payload) {
        state.otherReports = payload;
    },
    setUpsertDefition(state,payload){
        state.upsertDefinition = payload;
    },
    setReportFeeds(state,payload){
        state.reportFeeds = payload;
    },
    setUniqueAuthorChart(state,payload){
        state.uniqueAuthorChart = payload;
    },
    setEngagements(state,payload){
        state.engagements = payload;
    },
    setCategoryRates(state,payload){
        state.categoryRates = payload;
    },
    setSentimentChart(state,payload){
        state.sentimentChart = payload;
    },
    setSocialMediaRates(state,payload){
        state.socialMediaRates = payload;
    },
    setInteractionChart(state,payload){
        state.interactionChart = payload;
    },
    setTalkRateChart(state,payload){
        state.talkRateChart = payload;
    },
    setLocationChart(state,payload){
        state.locationChart = payload;
    }
}